// @flow
import * as React from 'react'
import Global from '@emotion/global'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import { BrowserRouter } from 'react-router-dom'

ReactDOM.render(
  <>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    <Global
      css={{
        body: {
          margin: 0,
          padding: 0,
          fontFamily:
            '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif',
          boxSizing: 'border-box'
        }
      }}
    />
  </>,
  // $FlowFixMe
  document.getElementById('root')
)
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js